import { render } from "./EmptyModal.vue?vue&type=template&id=09855a30"
import script from "./EmptyModal.vue?vue&type=script&lang=js"
export * from "./EmptyModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__